<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('assistantWizard', ['name', 'error']),
  },
  methods: {
    ...mapActions('assistantWizard', ['next', 'updateName']),
    inputName(e) {
      this.updateName(e.target.value);
    },
    nameError() {
      return this.error === 'name';
    },
  },
};
</script>

<template>
  <section class="flex items-center flex-col">
    <form
      class="flex flex-col text-center w-full flex-1 mb-4 items-center"
      @submit.prevent="next()"
    >
      <label
        class="text-xl text-center text-slate-900 dark:text-slate-50 mb-8"
        for="name"
      >
        {{ $t('ASSISTANT_MGMT.WIZARD.PERSONA_LABEL') }}
      </label>
      <input
        id="name"
        type="text"
        :value="name"
        class="rounded-md !border-2 border-slate-100 text-center !w-80 h-10 leading-5"
        @input="inputName"
      />
      <span v-if="nameError()" class="message">
        {{ $t('ASSISTANT_MGMT.WIZARD.PERSONA_ERROR') }}
      </span>
    </form>
  </section>
</template>
